const NewReportTypes = {
	//TYPES FOR ATTENDANCE REPORT
	GET_ATTENDANCE_REPORT_START: 'get_attendance_start',
	GET_ATTENDANCE_REPORT_SUCCESS: 'get_attendance_success',
	GET_ATTENDANCE_REPORT_FAILURE: 'get_attendance_failure',
	GET_ATTENDANCE_REPORT_KEY: 'CreateAttendanceReportFromWeb',

	//TYPES FOR lEAVR REPORT
	GET_LEAVE_REPORT_START: 'get_leave_report_start',
	GET_LEAVE_REPORT_SUCCESS: 'get_leave_report_success',
	GET_LEAVE_REPORT_FAILURE: 'get_leave_report_failure',
	GET_LEAVE_REPORT_KEY: 'CreateLeaveReportFromWeb',

	//TYPES FOR SECTION WISE ATTENDANCE REPORT
	GET_SECTION_WISE_ATTENDANCE_REPORT_START: 'get_section_wise_attendance_report_start',
	GET_SECTION_WISE_ATTENDANCE_REPORT_SUCCESS: 'get_section_wise_attendance_report_success',
	GET_SECTION_WISE_ATTENDANCE_REPORT_FAILURE: 'get_section_wise_attendance_report_failure',
	GET_SECTION_WISE_ATTENDANCE_REPORT_KEY: 'CreateSectionWiseAttendanceReportFromWeb',

	// TYPES FOR DESIGNATION WISE LEAVE REPORT
	GET_DESIGNATION_WISE_LEAVE_REPORT_START: 'get_designation_wise_leave_report_start',
	GET_DESIGNATION_WISE_LEAVE_REPORT_SUCCESS: 'get_designation_wise_leave_report_success',
	GET_DESIGNATION_WISE_LEAVE_REPORT_FAILURE: 'get_designation_wise_leave_report_failure',
	GET_DESIGNATION_WISE_LEAVE_REPORT_KEY: 'CreateDesignationWiseLeaveReportFromWeb',

	// TYPES FOR EMPLOYEE LEAVE REPORT
	GET_EMPLOYEE_LEAVE_REPORT_START: 'get_employee_leave_report_start',
	GET_EMPLOYEE_LEAVE_REPORT_SUCCESS: 'get_employee_leave_report_success',
	GET_EMPLOYEE_LEAVE_REPORT_FAILURE: 'get_employee_leave_report_failure',
	GET_EMPLOYEE_LEAVE_REPORT_KEY: 'CreateEmployeeLeaveReportFromWeb',

	// TYPES FOR MANAGEMENT LEAVE REPORT
	GET_MANAGEMENT_LEAVE_REPORT_START: 'get_management_leave_report_start',
	GET_MANAGEMENT_LEAVE_REPORT_SUCCESS: 'get_management_leave_report_success',
	GET_MANAGEMENT_LEAVE_REPORT_FAILURE: 'get_management_leave_report_failure',
	GET_MANAGEMENT_LEAVE_REPORT_KEY: 'CreateManagementLeaveReportFromWeb',

	// TYPES FOR MONTHLY ATTENDANCE SUMMARY REPORT
	GET_MONTHLY_ATTENDANCE_SUMMARY_REPORT_START: 'get_monthly_attendance_summary_report_start',
	GET_MONTHLY_ATTENDANCE_SUMMARY_REPORT_SUCCESS: 'get_monthly_attendance_summary_report_success',
	GET_MONTHLY_ATTENDANCE_SUMMARY_REPORT_FAILURE: 'get_monthly_attendance_summary_report_failure',
	GET_MONTHLY_ATTENDANCE_SUMMARY_REPORT_KEY: 'CreateMonthlyAttendanceSummaryReportFromWeb',

	// TYPES FOR MONTHLY CHECKOUT REPORT
	GET_MONTHLY_CHECKOUT_REPORT_START: 'get_monthly_checkout_report_start',
	GET_MONTHLY_CHECKOUT_REPORT_SUCCESS: 'get_monthly_checkout_report_success',
	GET_MONTHLY_CHECKOUT_REPORT_FAILURE: 'get_monthly_checkout_report_failure',
	GET_MONTHLY_CHECKOUT_REPORT_KEY: 'CreateMonthlyCheckoutReportFromWeb',

	// TYPES FOR MONTHLY CHECKOUT DETAILS
	GET_MONTHLY_CHECKOUT_DETAILS_START: 'get_monthly_checkout_details_start',
	GET_MONTHLY_CHECKOUT_DETAILS_SUCCESS: 'get_monthly_checkout_details_success',
	GET_MONTHLY_CHECKOUT_DETAILS_FAILURE: 'get_monthly_checkout_details_failure',
	GET_MONTHLY_CHECKOUT_DETAILS_KEY: 'CreateMonthlyReportDetailsFromWeb',

	// TYPES FOR COMP OFF REPORT
	GET_COMPOFF_REPORT_START: 'get_compoff_report_start',
	GET_COMPOFF_REPORT_SUCCESS: 'get_compoff_report_success',
	GET_COMPOFF_REPORT_FAILURE: 'get_compoff_report_failure',
	GET_COMPOFF_REPORT_KEY: 'GetAllCompOffByOrgFromWeb',

	// TYPES FOR REFRESHMENT REPORT
	GET_REFRESHMENT_REPORT_START: 'get_refreshment_report_start',
	GET_REFRESHMENT_REPORT_SUCCESS: 'get_refreshment_report_success',
	GET_REFRESHMENT_REPORT_FAILURE: 'get_refreshment_report_failure',
	GET_REFRESHMENT_REPORT_KEY: 'GetRefreshmentAllowancesByOrganisationIDFromWeb',

	// TYPES FOR ON DUTY REPORT
	GET_ONDUTY_REPORT_START: 'get_on_duty_report_start',
	GET_ONDUTY_REPORT_SUCCESS: 'get_on_duty_report_success',
	GET_ONDUTY_REPORT_FAILURE: 'get_on_duty_report_failure',
	GET_ONDUTY_REPORT_KEY: 'CreateOnDutyReportFromWeb',

	// TYPES FOR GET ALL EMPLOYEES CHECK-IN/CHECK-OUT
	GET_ALL_EMPLOYEES_CHECKINOUT_START: 'get_all_employees_checkinout_start',
	GET_ALL_EMPLOYEES_CHECKINOUT_SUCCESS: 'get_all_employees_checkinout_success',
	GET_ALL_EMPLOYEES_CHECKINOUT_FAILURE: 'get_all_employees_checkinout_failure',
	GET_ALL_EMPLOYEES_CHECKINOUT_KEY: 'GetAllEmployeesCheckInOutFromWeb',

	//TYPES FOR CHECK-IN LOCKED REPORT
	CHECK_IN_LOCKED_START: 'check_in_locked_start',
	CHECK_IN_LOCKED_SUCCESS: 'check_in_locked_success',
	CHECK_IN_LOCKED_FAILURE: 'check_in_locked_failure',
	CHECK_IN_LOCKED_RESPONSE_CHANGED: 'check_in_locked_response_changed',
	CHECK_IN_LOCKED_RESPONSE_REST_START: 'check_in_locked_response_rest_start',
	CHECK_IN_LOCKED_KEY: 'CreateCheckInLockedReportFromWeb',

	CHECK_IN_LOCKED_HISTORY_START: 'check_in_locked_history_start',
	CHECK_IN_LOCKED_HISTORY_SUCCESS: 'check_in_locked_history_success',
	CHECK_IN_LOCKED_HISTORY_FAILURE: 'check_in_locked_history_failure',
	CHECK_IN_LOCKED_HISTORY_RESPONSE_CHANGED: 'check_in_locked_history_response_changed',
	CHECK_IN_LOCKED_HISTORY_RESPONSE_REST_START: 'check_in_locked_history_response_rest_start',
	CHECK_IN_LOCKED_HISTORY_KEY: 'CreateCheckInLockedHistoryReportFromWeb',

	CHECK_IN_LOCKED_EXCUSE_START: 'check_in_locked_excuse_start',
	CHECK_IN_LOCKED_EXCUSE_SUCCESS: 'check_in_locked_excuse_success',
	CHECK_IN_LOCKED_EXCUSE_FAILURE: 'check_in_locked_excuse_failure',
	CHECK_IN_LOCKED_EXCUSE_RESPONSE_CHANGED: 'check_in_locked_excuse_response_changed',
	CHECK_IN_LOCKED_EXCUSE_RESPONSE_REST_START: 'check_in_locked_excuse_response_rest_start',
	CHECK_IN_LOCKED_EXCUSE_KEY: 'CreateCheckInLockedExcuseFromWeb',

	CHECK_IN_UNLOCKED_HISTORY_START: 'check_in_unlocked_history_start',
	CHECK_IN_UNLOCKED_HISTORY_SUCCESS: 'check_in_unlocked_history_success',
	CHECK_IN_UNLOCKED_HISTORY_FAILURE: 'check_in_unlocked_history_failure',
	CHECK_IN_UNLOCKED_HISTORY_RESPONSE_CHANGED: 'check_in_unlocked_history_response_changed',
	CHECK_IN_UNLOCKED_HISTORY_RESPONSE_CHANGED_RESET:
		'check_in_unlocked_history_response_changed_reset',
	CHECK_IN_UNLOCKED_HISTORY_KEY: 'CreateCheckInUnlockedHistoryReportFromWeb',
	//END OF TYPES FOR CHECK-IN LOCKED REPORT

	// TYPES FOR FESTIVAL ADVANCE REPORT
	GET_FESTIVAL_ADVANCE_REPORT_START: 'get_festival_advance_report_start',
	GET_FESTIVAL_ADVANCE_REPORT_SUCCESS: 'get_festival_advance_report_success',
	GET_FESTIVAL_ADVANCE_REPORT_FAILURE: 'get_festival_advance_report_failure',
	GET_FESTIVAL_ADVANCE_REPORT_KEY: 'CreateFestivalAdvanceReportFromWeb',

	// TYPES FOR GET ALL FESTIVAL NAMES
	GET_ALL_FESTIVAL_NAMES_START: 'get_all_festival_names_start',
	GET_ALL_FESTIVAL_NAMES_SUCCESS: 'get_all_festival_names_success',
	GET_ALL_FESTIVAL_NAMES_FAILURE: 'get_all_festival_names_failure',
	GET_ALL_FESTIVAL_NAMES_KEY: 'GetAllFestivalNamesFromWeb',

	// TYPES FOR UPDATE FESTIVAL ADVANCE STATUS (APPROVE/REJECT)
	UPDATE_FESTIVAL_ADVANCE_STATUS_START: 'update_festival_advance_status_start',
	UPDATE_FESTIVAL_ADVANCE_STATUS_SUCCESS: 'update_festival_advance_status_success',
	UPDATE_FESTIVAL_ADVANCE_STATUS_FAILURE: 'update_festival_advance_status_failure',
	UPDATE_FESTIVAL_ADVANCE_STATUS_KEY: 'UpdateFestivalAdvanceStatusFromWeb',

	// TYPES FOR MEDICAL ALLOWANCE REPORT
	GET_MEDICAL_ALLOWANCE_REPORT_START: 'get_medical_allowance_report_start',
	GET_MEDICAL_ALLOWANCE_REPORT_SUCCESS: 'get_medical_allowance_report_success',
	GET_MEDICAL_ALLOWANCE_REPORT_FAILURE: 'get_medical_allowance_report_failure',
	GET_MEDICAL_ALLOWANCE_REPORT_KEY: 'CreateMedicalAllowanceReportFromWeb',

	// TYPES FOR UPDATE MEDICAL ALLOWANCE STATUS (APPROVE/REJECT)
	UPDATE_MEDICAL_ALLOWANCE_STATUS_START: 'update_medical_allowance_status_start',
	UPDATE_MEDICAL_ALLOWANCE_STATUS_SUCCESS: 'update_medical_allowance_status_success',
	UPDATE_MEDICAL_ALLOWANCE_STATUS_FAILURE: 'update_medical_allowance_status_failure',
	UPDATE_MEDICAL_ALLOWANCE_STATUS_KEY: 'UpdateMedicalAllowanceStatusFromWeb',
};

export default NewReportTypes;
